import React from 'react';
import { Menu } from '@headlessui/react';
import { EllipsisVerticalIcon } from '@heroicons/react/20/solid';
import { DocumentDuplicateIcon, TrashIcon } from '@heroicons/react/24/outline';

function classNames(...classes) {
  return classes.filter(Boolean).join(' ');
}

// Per-option overflow menu (⋮): Duplicate + Delete, collapsed off the row to keep
// the modifier row compact. Shared by both option-group modal forks so their row
// actions cannot drift apart. Visible stays on the row (frequent action); only
// the rarer actions live here.
const OptionRowMenu = ({ onDuplicate, onDelete }) => (
  <Menu as="div" className="relative inline-block text-left">
    <Menu.Button
      type="button"
      aria-label="Option actions"
      className="flex items-center rounded-full p-1 text-slate-400 hover:text-slate-600 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 dark:text-slate-300 dark:hover:text-sky-400"
    >
      <EllipsisVerticalIcon className="h-5 w-5" aria-hidden="true" />
    </Menu.Button>
    <Menu.Items className="absolute right-0 z-20 mt-1 w-36 origin-top-right rounded-md bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none dark:bg-slate-800 dark:ring-slate-600">
      <Menu.Item>
        {({ active }) => (
          <button
            type="button"
            onClick={onDuplicate}
            className={classNames(
              active ? 'bg-slate-100 dark:bg-slate-700' : '',
              'flex w-full items-center gap-2 px-3 py-2 text-sm text-slate-700 dark:text-slate-200',
            )}
          >
            <DocumentDuplicateIcon className="h-4 w-4" aria-hidden="true" />
            Duplicate
          </button>
        )}
      </Menu.Item>
      <Menu.Item>
        {({ active }) => (
          <button
            type="button"
            onClick={onDelete}
            className={classNames(
              active ? 'bg-red-50 dark:bg-red-900/30' : '',
              'flex w-full items-center gap-2 px-3 py-2 text-sm text-red-600 dark:text-red-400',
            )}
          >
            <TrashIcon className="h-4 w-4" aria-hidden="true" />
            Delete
          </button>
        )}
      </Menu.Item>
    </Menu.Items>
  </Menu>
);

export default OptionRowMenu;
